import { render, staticRenderFns } from "./ClosedSystemCard.vue?vue&type=template&id=3fcc0800&"
import script from "./ClosedSystemCard.vue?vue&type=script&lang=js&"
export * from "./ClosedSystemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports